import { Component, Input } from '@angular/core';
import { FieldType, FormlyFieldConfig } from '@ngx-formly/core';

@Component({
    selector: 'ups-subtitle',
    template: `<div class="sub-title slds-col">
    <span>{{ to.label }}</span>
  </div>`,
    styleUrls: ['./subtitle.type.component.scss'],
    standalone: false
})
export class SubtitleTypeComponent extends FieldType {
  @Input() set defaults(opt: FormlyFieldConfig) {
    this.field = opt;
  }
}
